import Vue from 'vue'
import urls from '../services.url.js'

export default {
  getClubList () {
    let target = urls.CLUB_URL
    return Vue.http.get(target)
  },
  getLeagueList () {
    let target = urls.LEAGUE_URL
    return Vue.http.get(target)
  }
}



// WEBPACK FOOTER //
// ./src/api/real-api/league.api.js